/**
 * NIHARA LUXURY FASHION ??? CENTRALIZED WISHLIST SYSTEM & ENGINE
 * Single Source of Truth for V3 Product Grid, PDP, Collection Grid, Wishlist Page, and Account Portal
 */
(function() {
  'use strict';

  if (window.NiharaWishlistEngine) {
    window.NiharaWishlistEngine.syncUI();
    return;
  }

  window.NiharaWishlistEngine = {
    // 1. Get canonical list of product handles/IDs
    getHandles: function() {
      var handles = [];
      var keys = ['nihara_wishlist', 'theme-wishlist', 'nihara_saved_items'];
      keys.forEach(function(key) {
        try {
          var raw = localStorage.getItem(key);
          if (raw) {
            var parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) {
              parsed.forEach(function(h) {
                var s = String(h).trim();
                if (s && !handles.includes(s)) handles.push(s);
              });
            }
          }
        } catch(e) {}
      });

      // Also harvest handles from rich items
      var items = this.getItems();
      items.forEach(function(it) {
        if (it) {
          var h = String(it.handle || it.id || '').trim();
          if (h && !handles.includes(h)) handles.push(h);
        }
      });
      return handles;
    },

    // 2. Get canonical list of product objects
    getItems: function() {
      var items = [];
      try {
        var raw = localStorage.getItem('nihara_wishlist_items');
        if (raw) {
          var parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) {
            parsed.forEach(function(it) {
              if (it && typeof it === 'object' && (it.handle || it.id)) {
                var matchH = String(it.handle || it.id).trim();
                if (!items.some(function(existing) { return String(existing.handle || existing.id).trim() === matchH; })) {
                  items.push(it);
                }
              }
            });
          }
        }
      } catch(e) {}
      return items;
    },

    // 3. Save wishlist state across all storage keys
    save: function(handlesList, itemsList, sourceAction) {
      var cleanHandles = [];
      (handlesList || []).forEach(function(h) {
        var s = String(h).trim();
        if (s && !cleanHandles.includes(s)) cleanHandles.push(s);
      });

      var cleanItems = [];
      (itemsList || []).forEach(function(it) {
        if (it && typeof it === 'object' && (it.handle || it.id)) {
          var matchH = String(it.handle || it.id).trim();
          if (!cleanItems.some(function(existing) { return String(existing.handle || existing.id).trim() === matchH; })) {
            cleanItems.push(it);
          }
        }
      });

      try {
        localStorage.setItem('nihara_wishlist_items', JSON.stringify(cleanItems));
        localStorage.setItem('theme-wishlist', JSON.stringify(cleanHandles));
        localStorage.setItem('nihara_wishlist', JSON.stringify(cleanHandles));
        localStorage.setItem('nihara_saved_items', JSON.stringify(cleanHandles));
      } catch(e) {}

      this.syncUI();

      var detail = { wishlist: cleanHandles, items: cleanItems, action: sourceAction || 'updated' };
      document.dispatchEvent(new CustomEvent('nihara:wishlist:updated', { detail: detail }));
      document.dispatchEvent(new CustomEvent('nihara:wishlist-updated', { detail: detail }));
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: detail }));
    },

    // 4. Check if item is wishlisted (Checks both ID and Handle)
    has: function(productDataOrKey) {
      if (!productDataOrKey) return false;
      var handles = this.getHandles();
      var items = this.getItems();

      var targets = [];
      if (typeof productDataOrKey === 'object') {
        if (productDataOrKey.id) targets.push(String(productDataOrKey.id).trim());
        if (productDataOrKey.handle) targets.push(String(productDataOrKey.handle).trim());
      } else {
        targets.push(String(productDataOrKey).trim());
      }

      return targets.some(function(t) {
        if (!t) return false;
        return handles.includes(t) || items.some(function(it) {
          return String(it.handle || '').trim() === t || String(it.id || '').trim() === t;
        });
      });
    },

    // 5. Toggle item across all Candidate Identifiers
    toggle: function(productData, wishBtn) {
      var candidates = [];
      if (productData) {
        if (productData.handle) {
          var hStr = String(productData.handle).trim();
          if (hStr && !candidates.includes(hStr)) candidates.push(hStr);
        }
        if (productData.id) {
          var idStr = String(productData.id).trim();
          if (idStr && !candidates.includes(idStr)) candidates.push(idStr);
        }
      }

      if (candidates.length === 0) return;

      var items = this.getItems();
      var handles = this.getHandles();

      // Find any matched item in stored items to harvest its twin identifier (ID/Handle)
      var matchedItem = items.find(function(it) {
        if (!it) return false;
        var itH = String(it.handle || '').trim();
        var itId = String(it.id || '').trim();
        return (itH && candidates.includes(itH)) || (itId && candidates.includes(itId));
      });

      if (matchedItem) {
        if (matchedItem.handle) {
          var mH = String(matchedItem.handle).trim();
          if (mH && !candidates.includes(mH)) candidates.push(mH);
        }
        if (matchedItem.id) {
          var mId = String(matchedItem.id).trim();
          if (mId && !candidates.includes(mId)) candidates.push(mId);
        }
      }

      var isSaved = candidates.some(function(c) {
        return handles.includes(c) || items.some(function(it) {
          return String(it.handle || '').trim() === c || String(it.id || '').trim() === c;
        });
      });

      if (isSaved) {
        // REMOVE ALL CANDIDATE IDENTIFIERS FROM HANDLES AND ITEMS
        handles = handles.filter(function(h) {
          var s = String(h).trim();
          return !candidates.includes(s);
        });

        items = items.filter(function(it) {
          var itH = String(it.handle || '').trim();
          var itId = String(it.id || '').trim();
          return !candidates.includes(itH) && !candidates.includes(itId);
        });

        this.save(handles, items, 'removed');
        this.showToast('Removed from Wishlist');
      } else {
        // ADD CANDIDATE IDENTIFIERS
        candidates.forEach(function(c) {
          if (c && !handles.includes(c)) handles.push(c);
        });

        if (!items.some(function(it) { return candidates.includes(String(it.handle || '').trim()) || candidates.includes(String(it.id || '').trim()); })) {
          if (productData.image && productData.image.indexOf('//') === 0) {
            productData.image = window.location.protocol + productData.image;
          }
          items.push(productData);
        }

        this.save(handles, items, 'added');
        this.showToast('??? Saved to Wishlist');
      }
    },

    // 6. Sync UI across all V3 cards, PDPs, and count badges
    syncUI: function() {
      var handles = this.getHandles();
      var items = this.getItems();
      var count = Math.max(handles.length, items.length);

      // Master list of all saved IDs and Handles
      var allSavedIdentifiers = [];
      (handles || []).forEach(function(h) {
        var s = String(h).trim();
        if (s && !allSavedIdentifiers.includes(s)) allSavedIdentifiers.push(s);
      });
      (items || []).forEach(function(it) {
        if (it) {
          if (it.id) {
            var idStr = String(it.id).trim();
            if (idStr && !allSavedIdentifiers.includes(idStr)) allSavedIdentifiers.push(idStr);
          }
          if (it.handle) {
            var hStr = String(it.handle).trim();
            if (hStr && !allSavedIdentifiers.includes(hStr)) allSavedIdentifiers.push(hStr);
          }
        }
      });

      // Update count badges
      document.querySelectorAll('.nih-wishlist-count, .wishlist-count, #wishlist-count, #nih-wishlist-count-badge').forEach(function(badge) {
        if (badge.id === 'nih-wishlist-count-badge') {
          badge.textContent = count + (count === 1 ? ' ITEM SAVED' : ' ITEMS SAVED');
        } else {
          badge.textContent = count;
        }
      });

      // Update ALL Heart Buttons across ALL V3 Sections & Product Cards
      document.querySelectorAll('.mobile-card-v3__wishlist, [data-wishlist-toggle], .mobile-pdp__share-btn[data-wishlist-toggle], .nih-wishlist-btn, .product-card__wishlist').forEach(function(btn) {
        var card = btn.closest('.mobile-card-v3') || btn.closest('.mobile-card-v2') || btn.closest('.mobile-card') || btn.closest('[data-product-handle]') || btn.closest('.mobile-pdp') || btn;

        var candidates = [];
        var attrList = [
          btn.getAttribute('data-product-handle'),
          btn.getAttribute('data-wishlist-toggle'),
          btn.getAttribute('data-product-id'),
          card ? card.getAttribute('data-product-handle') : null,
          card ? card.getAttribute('data-product-id') : null,
          card ? card.getAttribute('data-handle') : null,
          card ? card.getAttribute('data-id') : null
        ];

        attrList.forEach(function(attr) {
          if (attr) {
            var s = String(attr).trim();
            if (s && !candidates.includes(s)) candidates.push(s);
          }
        });

        var isWishlisted = candidates.some(function(cand) {
          return allSavedIdentifiers.includes(cand);
        });

        if (isWishlisted) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        }
      });
    },

    // 7. Toast notification
    showToast: function(msg) {
      var toast = document.getElementById('nih-wishlist-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'nih-wishlist-toast';
        toast.className = 'nih-w-toast';
        document.body.appendChild(toast);
      }
      toast.textContent = msg;
      toast.classList.add('is-visible');
      if (toast._timer) clearTimeout(toast._timer);
      toast._timer = setTimeout(function() {
        toast.classList.remove('is-visible');
      }, 2500);
    }
  };

  // Global Toggle Helper for Version 3 cards, PDPs, and Collection Grids
  window.NiharaWishlistToggle = function(e, btn) {
    if (e) {
      if (typeof e.preventDefault === 'function') e.preventDefault();
      if (typeof e.stopPropagation === 'function') e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
    if (!btn) return;

    // Debounce lock to prevent double-execution from inline onclick + global event delegation
    var now = Date.now();
    if (btn._lastToggleTime && (now - btn._lastToggleTime < 400)) {
      return;
    }
    btn._lastToggleTime = now;

    var card = btn.closest('.mobile-card-v3') || btn.closest('.mobile-card-v2') || btn.closest('.mobile-card') || btn.closest('[data-product-handle]') || btn.closest('.mobile-pdp') || btn;
    var handle = btn.getAttribute('data-product-handle') || btn.getAttribute('data-wishlist-toggle') || (card ? card.getAttribute('data-product-handle') : '') || '';
    var id = btn.getAttribute('data-product-id') || (card ? card.getAttribute('data-product-id') : '') || handle;
    var title = btn.getAttribute('data-product-title') || (card ? card.getAttribute('data-title') : '');
    var price = btn.getAttribute('data-product-price') || (card ? card.getAttribute('data-price') : '');
    var comparePrice = btn.getAttribute('data-product-compare-price') || '';
    var url = btn.getAttribute('data-product-url') || (card && card.querySelector('a[href*="/products/"]') ? card.querySelector('a[href*="/products/"]').getAttribute('href') : '/products/' + handle);
    var image = btn.getAttribute('data-product-image') || (card && card.querySelector('img') ? card.querySelector('img').getAttribute('src') : '');

    // Fallbacks for PDP pages
    if (!title || title === 'Nihara Silhouette') {
      var pdpTitle = document.querySelector('.mobile-pdp__title, h1.product-single__title, .product__title');
      if (pdpTitle) title = pdpTitle.textContent.trim();
    }
    if (!price) {
      var pdpPrice = document.querySelector('.mobile-pdp__price--current, .price-item--regular, .product__price');
      if (pdpPrice) price = pdpPrice.textContent.trim();
    }
    if (!image) {
      var pdpImg = document.querySelector('.mobile-pdp__main-img, .product-single__photo img, .product-gallery img');
      if (pdpImg) image = pdpImg.getAttribute('src');
    }

    var productData = {
      id: String(id || handle),
      handle: String(handle || id),
      title: title || 'Nihara Silhouette',
      price: price || '',
      compare_at_price: comparePrice,
      url: url || ('/products/' + handle),
      image: image || ''
    };

    window.NiharaWishlistEngine.toggle(productData, btn);
  };

  // Global Event Delegation for any wishlist button click on Homepage, PDP, Collection, etc.
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.mobile-card-v3__wishlist, [data-wishlist-toggle], .mobile-pdp__share-btn[data-wishlist-toggle], .nih-wishlist-btn');
    if (btn) {
      var now = Date.now();
      if (btn._lastToggleTime && (now - btn._lastToggleTime < 400)) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      window.NiharaWishlistToggle(e, btn);
    }
  }, true);

  // Sync UI on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { window.NiharaWishlistEngine.syncUI(); });
  } else {
    window.NiharaWishlistEngine.syncUI();
  }

  // Cross-tab synchronization via localStorage events
  window.addEventListener('storage', function(e) {
    if (['nihara_wishlist_items', 'theme-wishlist', 'nihara_wishlist'].includes(e.key)) {
      window.NiharaWishlistEngine.syncUI();
    }
  });

  // Re-sync on Shopify Section Load & Custom Wishlist Events
  ['shopify:section:load', 'nihara:wishlist:updated', 'nihara:wishlist-updated', 'wishlist:updated'].forEach(function(evtName) {
    document.addEventListener(evtName, function() {
      window.NiharaWishlistEngine.syncUI();
    });
  });

})();

